import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'
import momentTimeZone from 'moment-timezone'
import Amplify, { I18n } from 'aws-amplify'
import awsconfig from './aws-exports'
import { login } from './lang'
import 'moment/locale/es'
import App from './App'
import 'utils/charts'
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'
import { LimitationsProvider } from 'store/LimitationsProvider'
// or 'aws-amplify-react-native'
Amplify.configure(awsconfig) // All the parent knows is that it has modules ...
const authScreenLabels = login;

I18n.setLanguage('es')
I18n.putVocabularies(authScreenLabels)

moment.locale('es')
momentTimeZone.tz.setDefault('UTC')
// localStorage.clear();
ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
